import { render, staticRenderFns } from "./URegisterByAdmin.vue?vue&type=template&id=0329f159&scoped=true&"
import script from "./URegisterByAdmin.vue?vue&type=script&lang=ts&"
export * from "./URegisterByAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329f159",
  null
  
)

export default component.exports